import { Model } from "src/app/core/data/model";
export class NonDrawing extends Model {
  constructor() {
    super();
  }
}
